<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DMoThI/tc-custom/9780674915206.jpg?1718282806395" alt="This image is the cover for the book Burdens of Brotherhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burdens of Brotherhood
      </h1>
      <p class="bookDescription body article font2">
        <b>An informative look at the ever-changing relationship between France’s predominant non-Christian immigrant minorities over the course of 100 years.</b><br/><br/>Headlines from France suggest that Muslims have renewed an age-old struggle against Jews and that the two groups are once more inevitably at odds. But the past tells a different story. <i>The Burdens of Brotherhood</i> is a sweeping history of Jews and Muslims in France from World War I to the present. Here Ethan Katz introduces a richer and more complex world that offers fresh perspective for understanding the opportunities and challenges in France today.<br/><br/>Focusing on the experiences of ordinary people, Katz shows how Jewish–Muslim relations were shaped by everyday encounters and by perceptions of deeply rooted collective similarities or differences. We meet Jews and Muslims advocating common and divergent political visions, enjoying common culinary and musical traditions, and interacting on more intimate terms as neighbors, friends, enemies, and even lovers and family members. Drawing upon dozens of archives, newspapers, and interviews, Katz tackles controversial subjects like Muslim collaboration and resistance during World War II and the Holocaust, Jewish participation in French colonialism, the international impact of the Israeli–Arab conflict, and contemporary Muslim antisemitism in France.<br/><br/>We see how Jews and Muslims, as ethno-religious minorities, understood and related to one another through their respective relationships to the French state and society. Through their eyes, we see colonial France as a multiethnic, multireligious society more open to public displays of difference than its postcolonial successor. This book thus dramatically reconceives the meaning and history not only of Jewish–Muslim relations but ultimately of modern France itself.<br/><br/><b>Praise for <i>The Burdens of Brotherhood</i></b><br/><br/><b>Winner of the American Library in Paris Book Award</b><br/><br/><b>Winner of the J. Russell Major Prize for the Best Book in French History</b><br/><br/><b>Winner of the 2015 National Jewish Book Award for Writing Based on Archival Material</b><br/><br/><b>Winner of the 2016 David H. Pinkney Prize for the Best Book in French History</b><br/><br/><b>“A compelling, important, and timely history of Jewish/Muslim relations in France since 1914 that investigates the ways and venues in which Muslims and Jews interacted in metropolitan France . . . This insightful, well-researched, and elegantly written book is mandatory reading for scholars of the subject and for those approaching it for the first time.” —J. Haus, <i>Choice</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ethan B. Katz
      </h2>
      
      <p class="authorDescription body article">Ethan B. Katz is Assistant Professor of History at the University of Cincinnati.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harvard University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6856722d